export default __webpack_public_path__ + "media/images/mailer-new/welcome-icons/follow_step-on-3cb2dd48e4f99e96fe32ad788c54c503.png";